import { useMutation } from 'react-query';

function useUpdate<TPayload, TResult, TContext>(
  call: (payload: TPayload) => Promise<TResult>,
  options: UseUpdateOptions<TPayload, TResult, TContext>
): UseUpdateResult<TPayload, TResult, TContext> {
  return useMutation((p) => call(p), options);
}

export default useUpdate;
